"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DisplayPanel = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.some");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.function.name");

var _memoize2 = _interopRequireDefault(require("lodash/memoize"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _Fonts = require("../../../Assets/Fonts");

var _react = _interopRequireWildcard(require("react"));

var _reactTracking = _interopRequireDefault(require("react-tracking"));

var _reactWaypoint = _interopRequireDefault(require("react-waypoint"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Colors = _interopRequireDefault(require("../../../Assets/Colors"));

var _Events = _interopRequireDefault(require("../../../Utils/Events"));

var _resizer = require("../../../Utils/resizer");

var _ErrorBoundary = require("../../ErrorBoundary");

var _Helpers = require("../../Helpers");

var _Constants = require("../Constants");

var _VideoControls = require("../Sections/VideoControls");

var _ExternalTrackers = require("./ExternalTrackers");

var _trackOnce = require("./track-once");

var _dec, _dec2, _class, _class2, _class3, _temp;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    margin: auto;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    margin: auto;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    margin: auto;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    margin: 0 auto;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object['ke' + 'ys'](descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object['define' + 'Property'](target, property, desc); desc = null; } return desc; }

var DisplayPanel = (_dec = (0, _reactTracking.default)({
  page: "Article"
}, {
  dispatch: function dispatch(data) {
    return _Events.default.postEvent(data);
  }
}), _dec2 = (0, _trackOnce.trackImpression)(function () {
  return "panel";
}), _dec(_class = (_class2 = (_temp = _class3 =
/*#__PURE__*/
function (_Component) {
  _inherits(DisplayPanel, _Component);

  function DisplayPanel(props) {
    var _this;

    _classCallCheck(this, DisplayPanel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DisplayPanel).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "video", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", {
      isMuted: true,
      isPlaying: false,
      showCoverImage: false
    });

    _defineProperty(_assertThisInitialized(_this), "trackDuration", (0, _memoize2.default)(function (percentComplete) {
      _this.props.tracking.trackEvent({
        action: "Video duration",
        label: "Display ad video duration",
        percent_complete: percentComplete,
        campaign_name: _this.props.campaign.name,
        unit_layout: "panel"
      });
    }));

    _defineProperty(_assertThisInitialized(_this), "trackSeconds", (0, _memoize2.default)(function (secondsComplete) {
      _this.props.tracking.trackEvent({
        action: "Video seconds",
        label: "Display ad video seconds",
        seconds_complete: secondsComplete,
        campaign_name: _this.props.campaign.name,
        unit_layout: "panel"
      });
    }));

    _defineProperty(_assertThisInitialized(_this), "toggleMuted", function (e) {
      e.stopPropagation();

      _this.setState({
        isMuted: !_this.state.isMuted
      });
    });

    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handleMouseEnter = _this.handleMouseEnter.bind(_assertThisInitialized(_this));
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_assertThisInitialized(_this));
    _this.trackImpression = _this.trackImpression.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DisplayPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.video) {
        this.video.onended = this.pauseVideo;
      }
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate() {
      if (this.video) {
        this.video.removeEventListener("timeupdate", this.trackProgress.bind(this));
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.video) {
        this.video.addEventListener("timeupdate", this.trackProgress.bind(this));
        this.video.muted = this.state.isMuted;
      }
    }
  }, {
    key: "trackImpression",
    value: function trackImpression() {} // noop
    // TODO: This could be shared with <CanvasVideo />

  }, {
    key: "trackProgress",
    value: function trackProgress() {
      var secondsComplete = Math.floor(this.video.currentTime);
      var percentComplete = Math.floor(this.video.currentTime / this.video.duration * 100);
      var percentCompleteInterval = Math.floor(percentComplete / 25) * 25; // Track 25% duration intervals

      if (percentCompleteInterval > 0) {
        this.trackDuration(percentCompleteInterval);
      } // Track 3 & 10 seconds


      if (secondsComplete === 3 || secondsComplete === 10) {
        this.trackSeconds(secondsComplete);
      }
    }
  }, {
    key: "isWithinMediaArea",
    value: function isWithinMediaArea(event) {
      var valid = ["DisplayPanel__Image", "VideoContainer", "VideoContainer__VideoCover", "VideoContainer__VideoControls", "VideoContainer__video", "PlayButton", "PlayButton__PlayButtonCaret"];
      var withinMediaArea = valid.some(function (className) {
        return event.target.className.includes(className);
      });
      return withinMediaArea;
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault();
      var alreadyClicked = this.state.showCoverImage;
      var _this$props = this.props,
          campaign = _this$props.campaign,
          isMobile = _this$props.isMobile,
          tracking = _this$props.tracking,
          unit = _this$props.unit;
      var url = (0, _get2.default)(unit, "link.url", false);
      var isVideo = this.isVideo();

      var openUrl = function openUrl() {
        tracking.trackEvent({
          action: "Click",
          label: "Display ad clickthrough",
          entity_type: "display_ad",
          campaign_name: campaign.name,
          unit_layout: "panel"
        });
        if (url) window.open((0, _ExternalTrackers.replaceWithCacheBuster)(url, (0, _Constants.getCurrentUnixTimestamp)()) || "", "_blank");
      };

      if (isMobile) {
        if (isVideo) {
          if (this.isWithinMediaArea(event)) {
            this.trackVideoClick();
            this.toggleVideo();
          } else {
            openUrl();
          } // Image

        } else {
          if (this.isWithinMediaArea(event)) {
            if (alreadyClicked) {
              openUrl();
              this.toggleCoverImage();
            } else {
              this.toggleCoverImage();
            } // Clicked outside of the media area

          } else {
            openUrl();
          }
        } // Desktop

      } else {
        if (isVideo) {
          this.pauseVideo();
        }

        openUrl();
      }
    }
    /**
     * Handle MouseEnter, on desktop
     */

  }, {
    key: "handleMouseEnter",
    value: function handleMouseEnter() {
      if (this.props.isMobile) {
        return false;
      } else {
        if (this.isVideo()) {
          this.playVideo();
          this.props.tracking.trackEvent({
            action: "MouseEnter",
            label: "Display ad play video",
            entity_type: "display_ad",
            campaign_name: this.props.campaign.name,
            unit_layout: "panel"
          });
        } else {
          this.toggleCoverImage();
        }
      }
    }
    /**
     * Handle MouseLeave, on desktop
     */

  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      if (this.props.isMobile) {
        return false;
      } else {
        if (this.isVideo()) {
          this.pauseVideo();
        } else {
          this.toggleCoverImage();
        }
      }
    }
  }, {
    key: "toggleCoverImage",
    value: function toggleCoverImage() {
      if (this.props.unit.logo) {
        var _showCoverImage = !this.state.showCoverImage;

        this.setState({
          showCoverImage: _showCoverImage
        });
      }
    }
  }, {
    key: "toggleVideo",
    value: function toggleVideo() {
      if (this.state.isPlaying) {
        this.pauseVideo();
      } else {
        this.playVideo();
      }
    }
  }, {
    key: "pauseVideo",
    value: function pauseVideo() {
      if (this.video) {
        this.video.pause();
        this.setState({
          isPlaying: false
        });
      }
    }
  }, {
    key: "playVideo",
    value: function playVideo() {
      if (this.video) {
        this.video.play();
        this.setState({
          isPlaying: true
        });
      }
    }
    /**
     * Handle clicks to Video player
     */

  }, {
    key: "trackVideoClick",
    value: function trackVideoClick() {
      this.props.tracking.trackEvent({
        action: "Click",
        label: "Display ad play video",
        entity_type: "display_ad",
        campaign_name: this.props.campaign.name,
        unit_layout: "panel"
      });
    }
  }, {
    key: "isVideo",
    value: function isVideo() {
      var assetUrl = (0, _get2.default)(this.props.unit, "assets.0.url", "");
      var isVideo = assetUrl.includes("mp4");
      return isVideo;
    }
  }, {
    key: "renderVideoIcon",
    value: function renderVideoIcon() {
      var _this$state = this.state,
          isPlaying = _this$state.isPlaying,
          isMuted = _this$state.isMuted;
      var isMobile = this.props.isMobile;

      if (isMobile) {
        return null;
      } else if (isPlaying && isMuted) {
        return _react.default.createElement(MutedIcon, {
          onClick: this.toggleMuted
        }, _react.default.createElement("svg", {
          width: "30",
          height: "30",
          xmlns: "http://www.w3.org/2000/svg"
        }, _react.default.createElement("g", {
          fill: "#FFF"
        }, _react.default.createElement("path", {
          d: "M29.514 28L19.13 17.614 9.557 8.043 1.514 0 0 1.514l6.529 6.529H.757V21.47H11.83l7.3 7.286v-8.114L28 29.514zM19.129.757l-7.3 7.286 7.3 7.3z"
        }))));
      } else if (isPlaying && !isMuted) {
        return _react.default.createElement(UnmutedIcon, {
          onClick: this.toggleMuted
        }, _react.default.createElement("svg", {
          width: "30",
          height: "30",
          xmlns: "http://www.w3.org/2000/svg"
        }, _react.default.createElement("g", {
          fill: "#FFF"
        }, _react.default.createElement("path", {
          d: "M18 12.864V0l-7.152 7.286H0v13.428h10.848L18 28V12.864z"
        }))));
      } else {
        return _react.default.createElement(VideoPlayIcon, null);
      }
    }
  }, {
    key: "renderVideo",
    value: function renderVideo(url) {
      var _this2 = this;

      var isPlaying = this.state.isPlaying;
      var isMobile = this.props.isMobile;
      return _react.default.createElement(VideoContainer, {
        className: "VideoContainer"
      }, !isPlaying && _react.default.createElement(VideoCover, {
        className: "VideoContainer__VideoCover"
      }, isMobile && _react.default.createElement(_VideoControls.VideoControls, {
        mini: true,
        className: "VideoContainer__VideoControls"
      })), _react.default.createElement("video", {
        playsInline: true,
        src: url,
        className: "VideoContainer__video",
        controls: false,
        ref: function ref(video) {
          return _this2.video = video;
        }
      }), this.renderVideoIcon());
    }
  }, {
    key: "render",
    value: function render() {
      var showCoverImage = this.state.showCoverImage;
      var _this$props2 = this.props,
          unit = _this$props2.unit,
          campaign = _this$props2.campaign,
          isMobile = _this$props2.isMobile,
          renderTime = _this$props2.renderTime;
      var url = (0, _get2.default)(unit.assets, "0.url", "");
      var isVideo = this.isVideo();
      var imageUrl = isVideo ? url : (0, _resizer.crop)(url, {
        width: 680,
        height: 284,
        isDisplayAd: true
      });
      var hoverImageUrl = (0, _resizer.resize)(unit.logo, {
        width: 680,
        isDisplayAd: true
      });
      var coverUrl = unit.cover_image_url && (0, _resizer.crop)(unit.cover_image_url, {
        width: 680,
        height: 284,
        isDisplayAd: true
      });
      return _react.default.createElement(_ErrorBoundary.ErrorBoundary, null, _react.default.createElement(Wrapper, {
        onClick: this.handleClick,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, _react.default.createElement(_reactWaypoint.default, {
        onEnter: this.trackImpression
      }), _react.default.createElement(DisplayPanelContainer, {
        className: "DisplayPanel__DisplayPanelContainer",
        imageUrl: imageUrl,
        isMobile: isMobile,
        hoverImageUrl: hoverImageUrl,
        coverUrl: coverUrl,
        showCoverImage: showCoverImage
      }, isVideo ? this.renderVideo(url) : _react.default.createElement(Image, {
        className: "DisplayPanel__Image"
      }), _react.default.createElement("div", null, _react.default.createElement(Headline, null, unit.headline), _react.default.createElement(Body, {
        dangerouslySetInnerHTML: {
          __html: unit.body
        }
      }), _react.default.createElement(SponsoredBy, null, "Sponsored by ".concat(campaign.name)))), _react.default.createElement(_ExternalTrackers.PixelTracker, {
        unit: unit,
        date: renderTime
      })));
    }
  }]);

  return DisplayPanel;
}(_react.Component), _defineProperty(_class3, "defaultProps", {
  tracking: {
    trackEvent: function trackEvent(x) {
      return x;
    }
  }
}), _temp), (_applyDecoratedDescriptor(_class2.prototype, "trackImpression", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "trackImpression"), _class2.prototype)), _class2)) || _class);
exports.DisplayPanel = DisplayPanel;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "DisplayPanel__Wrapper",
  componentId: "sc-1e0gfmg-0"
})(["cursor:pointer;text-decoration:none;color:black;max-width:360px;", ";"], _Helpers.pMedia.sm(_templateObject()));

var Image = _styledComponents.default.div.withConfig({
  displayName: "DisplayPanel__Image",
  componentId: "sc-1e0gfmg-1"
})(["margin-bottom:15px;width:100%;height:142px;background-color:black;box-sizing:border-box;"]);

var VideoCover = _styledComponents.default.div.withConfig({
  displayName: "DisplayPanel__VideoCover",
  componentId: "sc-1e0gfmg-2"
})(["margin-bottom:15px;width:100%;height:142px;background-color:black;box-sizing:border-box;position:absolute;display:flex;align-items:center;justify-content:center;"]);

var DisplayPanelContainer = _styledComponents.default.div.withConfig({
  displayName: "DisplayPanel__DisplayPanelContainer",
  componentId: "sc-1e0gfmg-3"
})(["display:flex;flex-direction:column;border:1px solid ", ";padding:20px;max-width:360px;box-sizing:border-box;", "{background:url(", ") no-repeat center center;background-size:cover;", ";}", "{background:url(", ") no-repeat center center;background-size:cover;", ";}", ";", ";", ";"], _Colors.default.grayRegular, Image, function (p) {
  return p.imageUrl || "";
}, function (p) {
  return p.showCoverImage && p.hoverImageUrl && "\n        background: black url(".concat(p.hoverImageUrl, ") no-repeat center center;\n        background-size: contain;\n        border: 10px solid black;\n    ");
}, VideoCover, function (p) {
  return p.coverUrl || "";
}, function (p) {
  return p.showCoverImage && !p.isMobile && "display: none;";
}, _Helpers.pMedia.md(_templateObject2()), _Helpers.pMedia.sm(_templateObject3()), _Helpers.pMedia.xs(_templateObject4()));

var Headline = _styledComponents.default.div.withConfig({
  displayName: "DisplayPanel__Headline",
  componentId: "sc-1e0gfmg-4"
})(["", ";line-height:1.23em;margin-bottom:3px;"], (0, _Fonts.unica)("s16", "medium"));

var Body = _styledComponents.default.div.withConfig({
  displayName: "DisplayPanel__Body",
  componentId: "sc-1e0gfmg-5"
})(["", ";line-height:1.53em;margin-bottom:20px;a{color:black;}"], (0, _Fonts.garamond)("s17"));

var SponsoredBy = _styledComponents.default.div.withConfig({
  displayName: "DisplayPanel__SponsoredBy",
  componentId: "sc-1e0gfmg-6"
})(["", ";color:", ";"], (0, _Fonts.avantgarde)("s11"), _Colors.default.grayRegular);

var VideoContainer = (0, _styledComponents.default)(Image).withConfig({
  displayName: "DisplayPanel__VideoContainer",
  componentId: "sc-1e0gfmg-7"
})(["position:relative;overflow:hidden;display:flex;align-items:center;video{object-fit:cover;object-position:50%;width:100%;height:100%;}"]);

var iconPositioning = function iconPositioning(side) {
  return "\n  position: absolute;\n  bottom: 13px;\n  ".concat(side, ": 15px;\n");
};

var VideoPlayIcon = _styledComponents.default.div.withConfig({
  displayName: "DisplayPanel__VideoPlayIcon",
  componentId: "sc-1e0gfmg-8"
})(["color:white;border-top:13px solid transparent;border-bottom:13px solid transparent;border-left:20px solid white;", ";"], iconPositioning("left"));

var MutedIcon = _styledComponents.default.div.withConfig({
  displayName: "DisplayPanel__MutedIcon",
  componentId: "sc-1e0gfmg-9"
})(["", ";"], iconPositioning("right"));

var UnmutedIcon = _styledComponents.default.div.withConfig({
  displayName: "DisplayPanel__UnmutedIcon",
  componentId: "sc-1e0gfmg-10"
})(["z-index:3;", ";right:14px;bottom:12px;"], iconPositioning("right")); // Set names for tests and DOM


DisplayPanelContainer.displayName = "DisplayPanelContainer";
Image.displayName = "Image";
VideoContainer.displayName = "VideoContainer";
VideoCover.displayName = "VideoCover";
Wrapper.displayName = "Wrapper";
//# sourceMappingURL=DisplayPanel.js.map